module.exports = "<div class=\"alerts-container\">\r\n    <div *ngFor=\"let alert of alerts\" class=\"alert alert-{{alert.type}}\" [attr.data-alert-id]=\"alert.timestamp.getTime()\">\r\n        <strong>{{ alert.timestamp | date:'HH:mm:ss' }}</strong>\r\n        {{ alert.message }}\r\n        <button type=\"button\" class=\"close\" (click)=\"removeAlert(alert)\">\r\n            <span>&times;</span>\r\n        </button>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/notifications/notifications.component.html
// module id = ./src/app/shared/components/notifications/notifications.component.html
// module chunks = main